/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FiltersInputs */

const en_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const es_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const fr_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres`)
};

const de_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const ja_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込み`)
};

const zh_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选`)
};

const ar_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عوامل التصفية`)
};

const id_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const it_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri`)
};

const ru_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры`)
};

const pt_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const ko_filters = /** @type {(inputs: FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {FiltersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const filters = /** @type {((inputs?: FiltersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FiltersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filters(inputs)
	if (locale === "es") return es_filters(inputs)
	if (locale === "fr") return fr_filters(inputs)
	if (locale === "de") return de_filters(inputs)
	if (locale === "ja") return ja_filters(inputs)
	if (locale === "zh") return zh_filters(inputs)
	if (locale === "ar") return ar_filters(inputs)
	if (locale === "id") return id_filters(inputs)
	if (locale === "it") return it_filters(inputs)
	if (locale === "ru") return ru_filters(inputs)
	if (locale === "pt") return pt_filters(inputs)
	return ko_filters(inputs)
});